import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const year = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1C19] text-[#E2E0D9]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <div className="font-serif-display text-3xl md:text-4xl text-white tracking-tight">
            Novi <span className="italic text-[#A88B7D]">Hotel</span>
          </div>
          <p className="mt-5 max-w-md text-sm md:text-base text-[#9a9a90] leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div className="md:col-span-6">
          <div className="overline text-[#A88B7D] mb-4">
            {t.footer.contactsLabel}
          </div>
          <ul className="space-y-2 text-sm md:text-base text-[#E2E0D9]">
            <li>L'Angelo di Barisone Giovanni & C. S.a.s.</li>
            <li>{t.contact.addressLines.slice(1).join(", ")}</li>
            <li>
              <a
                href="tel:+3901432935"
                className="hover:text-white transition-colors"
              >
                +39 0143 2935
              </a>
            </li>
            <li>
              <a
                href="mailto:info@langelosas.com"
                className="hover:text-white transition-colors"
              >
                info@langelosas.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#2a2d28]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-[#7a7a70]">
          <span>© {year} Novi Hotel — {t.footer.rights}</span>
          <span>{t.footer.vat}</span>
        </div>
      </div>
    </footer>
  );
}
